exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.excel-upload-input[data-v-48f05a0c] {\n  display: none;\n  z-index: -9999;\n}\n.drop[data-v-48f05a0c] {\n  position: relative;\n}\n", ""]);

// exports
